import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { RequestSettings, RequestSettingsUpdate } from './request-settings-service-types'

const getRequestSettingsUrl = (companyId: string) =>
  makeApiUrl(`/customer/v1/company/${companyId}/user-request-settings`)

export const createRequestSettingsService = (client = httpServiceClient) => ({
  async fetchSettings(companyId: string) {
    const response = await client<RequestSettings>({
      method: 'get',
      url: getRequestSettingsUrl(companyId)
    })

    return response.body.data as RequestSettings
  },

  async updateSettings(companyId: string, payload: RequestSettingsUpdate) {
    await client<void>({
      method: 'put',
      url: getRequestSettingsUrl(companyId),
      body: payload
    })
  }
})

export const requestSettingsService = createRequestSettingsService()

export const REQUEST_SETTINGS_QUERY_KEY = 'request-settings'

export const requestSettingsQueryOptions = (companyId: string) => ({
  queryKey: [REQUEST_SETTINGS_QUERY_KEY, companyId],
  queryFn: () => requestSettingsService.fetchSettings(companyId),
  staleTime: 5 * 60 * 1000
})
